const base = process.env.PUBLIC_URL ?? ''

const movies = [
    {
        imgUrl: `${base}/assets/movies1.webp`,
        title: "Barbie A Estrela do Rock (1987)"
    },
    {
        imgUrl: `${base}/assets/movies2.webp`,
        title:"Barbie Em Quebra Nozes (2001)"
    },
    {
        imgUrl: `${base}/assets/movies3.jpg`,
        title:"Barbie como Rapunzel (2002)"
    },
    {
        imgUrl: `${base}/assets/movies4.webp`,
        title:"Barbie Lago dos Cisnes (2003)"
    },
    {
        imgUrl: `${base}/assets/movies5.jpg`,
        title:"Barbie em a Princesa e a Plebeia (2004)"
    },
    {
        imgUrl: `${base}/assets/movies6.jpg`,
        title:"Barbie Fairytopia (2005)"
    },
    {
        imgUrl: `${base}/assets/movies7.jpg`,
        title:"Barbie em a Magia de Aladus (2005)"
    },
    {
        imgUrl: `${base}/assets/movies8.jpg`,
        title:"O Diário da Barbie (2006)"
    },
    {
        imgUrl: `${base}/assets/movies9.jpg`,
        title:"Barbie Fairytopia Mermaidia (2006)"
    },
    {
        imgUrl: `${base}/assets/movies10.png`,
        title:"Barbie As 12 Princesas Bailarinas (2006)"
    },
    {
        imgUrl: `${base}/assets/movies11.jpg`,
        title:"Barbie Fairytopia A Magia do Arco Íris (2007)"
    },
    {
        imgUrl: `${base}/assets/movies12.png`,
        title:"Barbie Em a Princesa da Ilha (2007)"
    },
    {
        imgUrl: `${base}/assets/movies13.webp`,
        title:"Barbie Butterfly A Nova Aventura Em Fairytopia (2008)"
    },
    {
        imgUrl: `${base}/assets/movies14.webp`,
        title:"Barbie e o Castelo de Diamante (2008)"
    },
    {
        imgUrl: `${base}/assets/movies15.webp`,
        title:"Barbie Em A Canção De Natal (2008)"
    },
    {
        imgUrl: `${base}/assets/movies16.jpg`,
        title:"Barbie Em A Pequena Polegar (2009)"
    },
    {
        imgUrl: `${base}/assets/movies17.webp`,
        title:"Barbie e as Três Mosqueteiras (2009)"
    },
    {
        imgUrl: `${base}/assets/movies18.jpg`,
        title:"Barbie em Vida de Sereia (2010)"
    },
    {
        imgUrl: `${base}/assets/movies19.jpg`,
        title:"Barbie Moda e Magia (2010)"
    },
    {
        imgUrl: `${base}/assets/movies20.png`,
        title:"Barbie E o Segredo Das Fadas (2011)"
    },
    {
        imgUrl: `${base}/assets/movies21.jpg`,
        title:"Barbie Escola de Princesas (2011)"
    },
    {
        imgUrl: `${base}/assets/movies22.webp`,
        title:"Barbie Um Natal Perfeito (2011)"
    },
    {
        imgUrl: `${base}/assets/movies23.jpg`,
        title:"Barbie Em Vida de Sereia 2 (2012)"
    },
    {
        imgUrl: `${base}/assets/movies24.jpg`,
        title:"Barbie em a Princesa e a Pop Star (2012)"
    },
    {
        imgUrl: `${base}/assets/movies25.jpg`,
        title:"Barbie e as Sapatilhas Mágicas (2013)"
    },
    {
        imgUrl: `${base}/assets/movies26.jpg`,
        title:"Barbie Butterfly e a Princesa Fairy (2013)"
    },
    {
        imgUrl: `${base}/assets/movies27.webp`,
        title:"Barbie e Suas Irmãs em uma Aventura de Cavalos (2013)"
    },
    {
        imgUrl: `${base}/assets/movies28.jpg`,
        title:"Barbie – A sereia das Pérolas (2014)"
    },
    {
        imgUrl: `${base}/assets/movies29.jpg`,
        title:"Barbie e o Portal Secreto (2014)"
    },
    {
        imgUrl: `${base}/assets/movies30.jpg`,
        title:"Barbie – Super Princesa (2015)"
    },
    {
        imgUrl: `${base}/assets/movies31.jpg`,
        title:"Barbie – Rainhas do Rock  (2015)"
    },
    {
        imgUrl: `${base}/assets/movies32.jpg`,
        title:"Barbie e Suas Irmãs em Uma Aventura de Cachorrinhos (2015)"
    },
    {
        imgUrl: `${base}/assets/movies33.jpg`,
        title:"Barbie e as Agentes Secretas (2016)"
    },
    {
        imgUrl: `${base}/assets/movies34.jpg`,
        title:"Barbie: Aventura Nas Estrelas (2016)"
    },
    {
        imgUrl: `${base}/assets/movies35.jpg`,
        title:"Barbie e Suas Irmãs em Busca dos Cachorrinhos (2016)"
    },
    {
        imgUrl: `${base}/assets/movies36.png`,
        title:"Barbie em Um Mundo de Vídeo Game (2017)"
    },
    {
        imgUrl: `${base}/assets/movies37.webp`,
        title:"Barbie e os Golfinhos Mágicos (2017)"
    },
    
];

export default movies